// @flow

export default function apiImage(path: string): string {
  return path;
}
